import React, { FC } from 'react';
import KTileItem from './KTileItem';
import KTilePlaceholder from './KTilePlaceholder';
import { SelectPosActions } from '../ccson/TileMap';
import { KActionDTO, KPosition, KTileDTO } from '@envclient/envengine/src/envs/koenigsburg/KTile';
import { MeepleDTO, MeepleType } from '@envclient/envengine/src/envs/tilebase/Meeple';
import { CSSPos } from '../../types/frontendTypes';

export type Positions = Record<string, { coord: string; position: KPosition; actions: KActionDTO[] }>;

interface KTilePhaseProps {
  active: boolean;
  lastTiles: KTileDTO[];
  selectedTileId: number | null;
  selectedAction: KActionDTO | null;
  posActions: KActionDTO[];
  preferredMeepleType: MeepleType | undefined;
  tilePositions: Positions;
  startStyle?: CSSPos | null;
  dragTileId?: number | null;
  dragPos?: CSSPos | null;
  tilePlaceholderClick: (args: SelectPosActions) => void;
  selectedTileClick: (action: KActionDTO) => void;
  tempTileClick: (tile: KTileDTO) => void;
  lastMeepleClick: (meeple: MeepleDTO) => void;
  onTileDragStart: (
    tile: KTileDTO,
    clientX: number,
    clientY: number,
    rect: DOMRect,
    sourceScale: number,
    pointerId: number
  ) => void;
}

const KTilePhase: FC<KTilePhaseProps> = ({
  active,
  lastTiles,
  selectedTileId,
  selectedAction,
  posActions,
  preferredMeepleType,
  tilePositions,
  startStyle,
  dragTileId,
  dragPos,
  tilePlaceholderClick,
  selectedTileClick,
  tempTileClick,
  lastMeepleClick,
  onTileDragStart
}) => {
  return (
    <>
      {active &&
        Object.values(tilePositions).map((p) => (
          <KTilePlaceholder
            key={p.coord}
            position={p.position}
            coord={p.coord}
            actions={p.actions}
            onClick={tilePlaceholderClick}
          />
        ))}
      {lastTiles?.map((t) => {
        // while dragging, render the dragged tile once as a ghost that follows the cursor
        if (t.id === dragTileId && dragPos) {
          const ghostTile = selectedAction?.tile.id === t.id ? selectedAction.tile : t;
          return (
            <KTileItem
              key={t.id}
              active={true}
              selected={true}
              tile={ghostTile}
              preferredMeepleType={preferredMeepleType}
              tempPos={dragPos}
              dragging={true}
            />
          );
        }
        // render selected tile with actions
        if (t.id === selectedTileId && active && selectedAction) {
          return (
            <KTileItem
              key={t.id}
              active={true}
              selected={true}
              tile={selectedAction.tile}
              posActions={posActions}
              onClick={selectedTileClick}
              onDragStart={onTileDragStart}
              onMeepleClick={lastMeepleClick}
              preferredMeepleType={preferredMeepleType}
              selectedAction={selectedAction}
              startStyle={startStyle ?? undefined}
            />
          );
        }
        // temp tiles (placed temp tiles - minus the selected tile)
        if (t.isTemp) {
          return <KTileItem key={t.id} active={true} tile={t} onTempClick={tempTileClick} onDragStart={onTileDragStart} />;
        }
        return null;
      })}
    </>
  );
};

export default KTilePhase;
